<div class="p-fluid p-mb-5">

  <kodit-stranka-eotpremnice-autocomplete
    (onPravnoLiceChange)="onSelectionChange($event)"
    (onNazivChange)="handleNazivChange($event)"
    (onClear)="onSelectionClear()"
    [jePrevoznik]="true"
  ></kodit-stranka-eotpremnice-autocomplete>

  <div *ngIf="nazivNepronadjeneStranke" class="p-mt-3">
    <kodit-field
      [fieldLabel]="
        'U bazi nema rezultata za unetu vrednost [' +
        nazivNepronadjeneStranke +
        ']'
      "
    >
      <button
        pButton
        pRipple
        type="button"
        icon="fas fa-plus"
        class="p-mt-2 p-button-outlined btn-create-fizicko-lice"
        (click)="handleCreateFizickoLice()"
        label="Unesi fizičko lice"
        pTooltip="Unesite novo fizičko lice direktno sa račun forme"
      ></button>
    </kodit-field>
  </div>
</div>

<div
  *ngIf="fazeVoznje"
  [ngClass]="
    fazeVoznje.at(index)?.get('prevoznikDto')?.touched &&
    fazeVoznje.at(index)?.get('prevoznikDto')?.invalid
      ? 'stranka-invalid'
      : ''
  "
>
  <div class="p-field p-grid">
    <label class="p-col-fixed p-m-0" kodit-form-label>Naziv:</label>
    <div class="p-col stranka-text">
      <span>{{
       fazeVoznje.at(index)?.get('prevoznikDto')?.value?.id
          ? fazeVoznje.at(index)?.get('prevoznikDto')?.value?.naziv
          : fazeVoznje.at(index)?.get('prevoznikDto')?.value?.tipStranke ===
            fizickoLiceTip
          ? ''
          : fazeVoznje.at(index)?.get('prevoznikDto')?.value?.naziv
      }}</span>
    </div>
  </div>
  <div class="p-field p-grid">
    <label class="p-col-fixed p-m-0" kodit-form-label>Adresa:</label>
    <div class="p-col stranka-text">
      <span>{{
        fazeVoznje.at(index)?.get('prevoznikDto')?.value?.id
          ? fazeVoznje.at(index)?.get('prevoznikDto')?.value?.adresa
          : fazeVoznje.at(index)?.get('prevoznikDto')?.value?.tipStranke ===
            fizickoLiceTip
          ? ''
          : fazeVoznje.at(index)?.get('prevoznikDto')?.value?.adresa
      }}</span>
    </div>
  </div>
  <div class="p-field p-grid" *ngIf="!jeInostranoPravnoLice && fazeVoznje.at(index)?.get('prevoznikDto')?.value.tipStranke != fizickoLiceTip">
    <label class="p-col-fixed p-m-0" kodit-form-label>PIB:</label>
    <div class="p-col stranka-text">
      <span>{{ fazeVoznje.at(index).get('prevoznikDto')?.value?.pib }}</span>
    </div>
  </div>
  <div class="p-field p-grid" *ngIf="!jeInostranoPravnoLice">
    <label class="p-col-fixed p-m-0" kodit-form-label *ngIf="fazeVoznje.at(index)?.get('prevoznikDto')?.value?.tipStranke !== fizickoLiceTip">MB:</label>
    <label class="p-col-fixed p-m-0" kodit-form-label *ngIf="fazeVoznje.at(index)?.get('prevoznikDto')?.value?.tipStranke === fizickoLiceTip">JMBG:</label>
    <div class="p-col stranka-text">
      <span>{{ fazeVoznje.at(index).get('prevoznikDto')?.value?.mb }}</span>
    </div>

  <div class="p-field p-grid" *ngIf="jeInostranoPravnoLice">
    <label class="p-col-fixed p-m-0" kodit-form-label
      >Registracioni broj:</label
    >
    <div class="p-col stranka-text">
      <span>{{
        fazeVoznje.at(index).get('prevoznikDto')?.value?.registracioniBroj
      }}</span>
    </div>
  </div>
</div>
<small
  *ngIf="
    !fazeVoznje.at(index)?.get('prevoznikDto')?.valid &&
    fazeVoznje.at(index)?.get('prevoznikDto')?.touched
  "
  id="stranka-help"
  class="p-invalid"
  >Morate izabrati primaoca.</small
>
<kodit-nosioc-javne-nabavke
  *ngIf="fazeVoznje.at(index)?.get('prevoznikDto')?.value?.jbkjs"
  [formCtrl]="fazeVoznje.at(index)?.get('prevoznikDto')?.value?.nosiocJavneNabavke"
></kodit-nosioc-javne-nabavke>
